




















































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
// helpers
//import { idtify } from "@/helpers/string";
// tipos
//import { Rutas } from "@/typings/store/modules/rutas";
//import {
//  Permisos,
//  TipoUsuario,
//  Usuario,
//} from "@/typings/store/plugins/easyFirestore/usuarios";
import {
  SaldoCuenta,
  //Bancos
} from "@/typings/store/plugins/easyFirestore/saldoCuentas";
// validaciones
import {
  // email,
  required,
} from "vuelidate/lib/validators";
import { DataFormularioSaldoCuenta } from "@/typings/components/saldoCuentas/formulario";
import SVGIcon from "@/components/SVGIcon.vue";
//import { Archivo, Archivos } from "@/typings/store/modules/archivos";

@Component({
  components: {
    SVGIcon,
  },
  validations: {
    nombre: { required },
    posicion: { required },
  },
})
export default class FormularioBanco extends Vue {
  @Prop() readonly saldoCuenta!: SaldoCuenta | null;
  @Prop() readonly cargando!: boolean;
  //   @Prop() readonly rutas!: Rutas;
  //   @Prop() readonly ciudades!: Ciudad[];
  //   @Prop() readonly cargando!: boolean;
  //   @Prop() readonly regiones!: Region[];

  created(): void {
    // Object.keys(this.rutas).forEach((key) => {
    //   this.$set(this.permisos, key, false);
    // });
    // console.log(this.permisos);
    const saldoCuenta = this.saldoCuenta;
    if (!saldoCuenta) {
      return;
    }
    this.id = saldoCuenta.id ?? "";
    this.nombre = saldoCuenta.nombre;
    this.posicion = saldoCuenta.posicion ?? "";
  }

  id: string | null = null;

  nombre = "";
  posicion = "";

  get titulo(): string {
    return this.saldoCuenta ? "editar saldoCuenta" : "nuevo saldoCuenta";
  }

  //   get permisosKey(): Array<string> {
  //     // return Object.keys(this.permisos).filter((key) => {
  //     //   if(this.rutas[key].tipos.includes(this.tipo)){
  //     //     this.permisos[key] = true;
  //     //   }
  //     // });
  //     return Object.keys(this.permisos).filter((key) => {
  //       if (!this.rutas[key]) {
  //         return false;
  //       }
  //       const tipo = this.rutas[key].tipos.includes(this.tipo);
  //       return tipo;
  //     });
  //   }

  get nombreError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.nombre.$dirty) return errors;
    if (!this.$v.nombre.required) errors.push("Completar datos obligatorios");
    return errors;
  }

  get posicionError(): Array<string> {
    const errors: Array<string> = [];
    if (!this.$v.posicion.$dirty) return errors;
    if (!this.$v.posicion.required) errors.push("Completar datos obligatorios");
    return errors;
  }

  @Emit("close")
  onClose(): null {
    return null;
  }

  @Emit("cerrar-dialogo")
  onCerrarDialogo(): void {
    return;
  }

  @Emit("click-guardar")
  onClickGuardar(data: DataFormularioSaldoCuenta): DataFormularioSaldoCuenta {
    return data;
  }

  //   @Watch("permisosKey", { immediate: true })
  //   onTipoChange(): void {
  //     console.log("a");
  //     for (const key of Object.keys(this.permisos)) {
  //       if (this.permisos[key]) {
  //         this.permisos[key] = false;
  //       }
  //     }
  //     this.permisosKey.forEach((key) => {
  //       this.permisos[key] = true;
  //     });
  //   }

  //   nombrePermiso(key: string): string {
  //     return this.rutas[key].text;
  //   }

  guardar(): void {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return;
    }
    const doc: SaldoCuenta = {
      nombre: this.nombre.toUpperCase(),
      posicion: this.posicion.toLowerCase(),
    };
    if (this.id) {
      doc.id = this.id;
    }
    const data: DataFormularioSaldoCuenta = {
      doc: doc,
    };
    this.onClickGuardar(data);
  }
}
